module.exports = __webpack_public_path__ + "static/media/workingmemory-words-2.44168200.mp3";